module.exports = __webpack_public_path__ + "media/images/app-night-87d0b2c6810d11db4b4be367d1f63d6f.png";